export enum SubmitRejection {
  FirstNameRequired = 'first_name_required',
  LastNameRequired = 'last_name_required',
  EmailRequired = 'email_required',
  PhoneRequired = 'phone_required',
  SsnRequired = 'ssn_required',
  DateOfBirthRequired = 'date_of_birth_required',
  ResidentialHistoryRequired = 'residential_history_required',
  RequiredQuestionsNotAnswered = 'required_questions_not_answered',
  RequiredFilesMissing = 'required_files_missing',
  TermsNotAccepted = 'terms_not_accepted',
  AlreadySubmitted = 'already_submitted',
}
